import React from "react";
import ImgHero from "../images/img-hero.png";
import FormCartao from "./FormDesbloqueio/FormCartao";
import { useCartao } from "../hooks/cartao";

const Desbloqueio: React.FC = () => {
  const { passo } = useCartao();
  return (
    <>
      {passo === 0 && (
        <section className="bg-theme2">
          <div className="container flex flex-col px-5 pt-5 lg:pt-10 mx-auto lg:flex-row lg:px-18 2lg:px-28 ">
            <div className="justify-center w-full p-8 hidden lg:flex lg:w-1/3 lg:w-5/6 lg:max-w-lg ">
              <img
                className="w-full rounded-lg"
                alt="Desbloquear cartão"
                src={ImgHero}
              />
            </div>
            <div className="flex flex-col items-start w-full py-2 lg:py-8 lg:mb-16 text-left lg:flex-grow lg:w-2/3 lg:w-1/2 lg:mr-4 lg:mr-20 lg:pr-4 lg:mb-0">
              <h1 className="pt-0 lg:pt-10 lg:mb-4 font-normal tracking-tighter text-xl lg:text-3xl text-theme text-center">
                A <b className="font-semibold">Dental Uni</b> se preocupa com segurança para que sua única preocupação seja encontrar mais motivos para sorrir!
              </h1>

              <p className="mb-8 py-2 lg:px-10 text-md lg:text-xl tracking-tighter leading-7 text-center text-gray-500 ">
                Por isso, os cartões do beneficiário devem ser desbloqueados
                antes do início do uso do plano odontológico.
              </p>
              <FormCartao />

              <p className="w-full mt-2 mb-8 text-center text-sm lg:text-lg lg:text-right px-10 py-2 text-gray-500">
                O CPF do titular desbloqueia o cartão de todos os dependentes menores de idade.
              </p>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Desbloqueio;
